import React, { ReactNode } from "react";
import styled from "styled-components";

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, auto) 35%;
  grid-template-rows: auto;
  grid-template-areas:
    "player bid"
    "info bid";
  grid-column-gap: 76px;
  grid-row-gap: 48px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-template-areas:
      "player"
      "bid"
      "info";
    grid-column-gap: 0;
  }
`;

const PlayerArea = styled.div`
  grid-area: player;
`;

const BidDetailsArea = styled.div`
  grid-area: bid;
`;

const InfoArea = styled.div`
  grid-area: info;
`;

interface IProps {
  player: ReactNode;
  bidInfo: ReactNode;
  musicInfo: ReactNode;
}

const AssetContentLayout = ({ player, bidInfo, musicInfo }: IProps) => {
  return (
    <Layout>
      <PlayerArea>{player}</PlayerArea>
      <BidDetailsArea>{bidInfo}</BidDetailsArea>
      <InfoArea>{musicInfo}</InfoArea>
    </Layout>
  );
};

export default AssetContentLayout;
